import React, { useState, useEffect, useRef, useContext } from "react";
import { Paper } from "@mui/material";
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import '../../../../Style/AccountingSheetStyle.scss'
import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { ApiLink } from '../../../../APILink/ApiLink';
import authHeader from '../../../../Auth/authHeader';
import LoginUserDetailed from '../../../../Auth/LoginUserDetailed';
import { deleteAlert, errorAlert, handleSuccess, noticeAlert } from '../../../../Components/Alerts';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { FaFilePdf, FaTable } from "react-icons/fa";
import Autocomplete from "@mui/material/Autocomplete";
import ReusableServerDataGrid from "../../../../Components/ReusableServerDataGrid";
import { AddElementsButton } from "../../../../Components/AddElementsButton";
import CompoundArticleForm from "../CompoundArticle/CompoundArticleForm";
// import InsertRecepture from '../../../CRUD/Article/InsertArticle';
import ItemFormModal from "../../../ArticleCRUD/ArticleModal";
import { gridHeader } from "./NormativGrid";
import '../../../../Produce/StandartProduction/Normativ/NormativProfessional.css';
import { useHistory, useLocation, useParams } from "react-router-dom";

function StandardNormativForm() {
    const history = useHistory();
    const location = useLocation();
    const { articleProductionID: routeArticleProductionID } = useParams();
    const [openDetails, setOpenDetails] = useState(false);

    const [articleProductions, setArticlProductions] = useState([]);
    const [simpleArticle, setSimpleArticle] = useState([]);

    const [articleProductionID, setArticleProductionID] = useState(0);
    const [simpeArticleID, setSimpleArticleID] = useState(0);
    const [qty, setQty] = useState(0);

    const [showEditForm, setShowEditForm] = useState(false);
    const [showInserForm, setShowInsertForm] = useState(true);
    const [changeButton, setChangeButton] = useState(false)
    const [isArticleModalOpen, setIsArticleModalOpen] = useState(false);

    const [showError, setShowError] = useState(false);
    const [sameArticleError, setSameArticleError] = useState("");
    const [compoundArticleError, setCompoundArticleError] = useState("");

    const [formDetailData, setFormDetailData] = useState({
        ArticleComponentsID: "",
        ArticleProductionID: "",
        ArticlesID: "",
        Qty: ""
    });

    const handleOpenForm2 = () => {
        setShowInsertForm(true);
        setShowEditForm(false); // I fsheh formën e parë
    };
    const handleOpenForm1 = () => {
        setShowInsertForm(false);
        setShowEditForm(true); // I fsheh formën e parë
    };

    const handleEnable = () => {
        setForm1IsDisabled(true);
        setForm2IsDisabled(false);
    }

    const headers = authHeader();
    const email = LoginUserDetailed();

    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

    const [data, setData] = useState([]);

    const [form1IsDisabled, setForm1IsDisabled] = useState(false);
    const [form2IsDisabled, setForm2IsDisabled] = useState(true);

    const queryArticleProductionID = Number(new URLSearchParams(location.search).get("articleProductionID"));
    const editArticleProductionID = Number(routeArticleProductionID || queryArticleProductionID || 0);
    const isEditMode = editArticleProductionID > 0;
    const isPdfEnabled = Number(articleProductionID) > 0 && data.length > 0;

    const formatDateDdMmYyyy = (value = new Date()) => {
        const dt = value instanceof Date ? value : new Date(value);
        if (Number.isNaN(dt.getTime())) {
            return "-";
        }
        const day = String(dt.getDate()).padStart(2, "0");
        const month = String(dt.getMonth() + 1).padStart(2, "0");
        const year = dt.getFullYear();
        return `${day}.${month}.${year}`;
    };

    const handleExportNormativPdf = () => {
        if (!isPdfEnabled) {
            errorAlert("PDF aktivizohet vetëm pasi të insertohen recepturat.");
            return;
        }

        const selectedCompound =
            articleCompound ||
            articleProductions.find((item) => Number(item.ArticleID) === Number(articleProductionID));

        const articleName = selectedCompound?.ArticleName || "Artikull i panjohur";
        const barcode = selectedCompound?.Barcode || "-";
        const articleType = Number(selectedCompound?.ArticleProduction) === 2 ? "Gjysëm Produkt" : "Produkt i Prodhuar";
        const generatedAt = formatDateDdMmYyyy(new Date());
        const totalComponents = data.length;
        const totalQty = data.reduce((sum, item) => sum + Number(item.Qty || 0), 0);

        const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
        const pageWidth = pdf.internal.pageSize.getWidth();

        pdf.setFillColor(21, 50, 75);
        pdf.rect(0, 0, pageWidth, 30, "F");
        pdf.setTextColor(255, 255, 255);
        pdf.setFont("helvetica", "bold");
        pdf.setFontSize(17);
        pdf.text("Normativ i Prodhimit", 14, 12);
        pdf.setFont("helvetica", "normal");
        pdf.setFontSize(10);
        pdf.text("Dokument standard për shfaqje dhe arkivim të recepturave", 14, 18);

        pdf.setTextColor(17, 38, 58);
        pdf.setFont("helvetica", "bold");
        pdf.setFontSize(10);
        pdf.text(`Artikulli: ${articleName}`, 14, 38);
        pdf.text(`Barkodi: ${barcode}`, 14, 44);
        pdf.text(`Lloji: ${articleType}`, 14, 50);
        pdf.text(`Data: ${generatedAt}`, 14, 56);

        const tableRows = data.map((item, index) => ([
            index + 1,
            item.Barcode || "-",
            item.ArticleName || "-",
            item.UnitName || "-",
            Number(item.Qty || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        ]));

        pdf.autoTable({
            startY: 63,
            head: [["#", "Barkodi", "Emërtimi", "Njësia", "Sasia"]],
            body: tableRows,
            styles: {
                font: "helvetica",
                fontSize: 9,
                cellPadding: 2.4,
                textColor: [17, 38, 58],
                lineColor: [220, 232, 239],
                lineWidth: 0.2,
            },
            headStyles: {
                fillColor: [248, 252, 255],
                textColor: [61, 86, 107],
                fontStyle: "bold",
            },
            columnStyles: {
                0: { cellWidth: 10, halign: "center" },
                1: { cellWidth: 30 },
                2: { cellWidth: 90 },
                3: { cellWidth: 25 },
                4: { cellWidth: 25, halign: "right" },
            },
            alternateRowStyles: { fillColor: [250, 252, 255] },
            margin: { left: 14, right: 14 },
        });

        const finalY = (pdf.lastAutoTable?.finalY || 63) + 10;
        pdf.setDrawColor(220, 232, 239);
        pdf.line(14, finalY - 3, pageWidth - 14, finalY - 3);
        pdf.setFont("helvetica", "bold");
        pdf.setFontSize(10);
        pdf.text(`Komponentë: ${totalComponents}`, 14, finalY + 3);
        pdf.text(
            `Totali i sasive: ${totalQty.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
            pageWidth - 14,
            finalY + 3,
            { align: "right" }
        );

        const fileSafeName = articleName.replace(/[\\/:*?"<>|]/g, "-").trim() || "Normativ";
        pdf.save(`Normativ-${fileSafeName}-${generatedAt}.pdf`);
    };

    const fetchArticlesProduction = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'CompoundArticle', { headers });
            setArticlProductions(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const fetchSimpleArticles = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'article', { headers });
            setSimpleArticle(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const fetchData = async (targetArticleProductionID = articleProductionID) => {
        if (!targetArticleProductionID) {
            setData([]);
            return [];
        }

        try {
            const response = await axios.get(ApiLink.API_URL + 'Normativi/articlesComponents', {
                headers,
                params: { compoudArticleID: targetArticleProductionID }
            });

            setData(response.data);
            return response.data || [];
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage || "Gabim nga serveri."}`);
            } else if (error.request) {
                errorAlert("Serveri nuk është i arritshëm. Kontrolloni lidhjen me internetin ose provoni më vonë.");
            } else {
                errorAlert(`Gabim: ${error.message}`);
            }

            return [];
        }
    };

    const handleDelete = async (deleteItemId) => {
        try {
            // const response = 
            await axios.delete(
                ApiLink.API_URL + 'Normativi' + `/${deleteItemId}`, { headers }
            );
            setShowDeleteConfirmation(false);
            deleteAlert("Receptura u fshi me sukses");
            fetchData();
        } catch (error) {
            deleteAlert("Receptura u fshi me sukses");
        }
    };

    const openRecepturForm = (event) => {
        event.preventDefault();
        if (articleProductionID == 0) {
            setCompoundArticleError("Ju lutem zgjedhni artikullin e përbërë.");
        } else {
            setCompoundArticleError("");
            handleEnable();
            setChangeButton(true);
            setOpenDetails(true);
            fetchData().then(response => {
                if (response.length > 0) {
                    noticeAlert("Artikulli i prodhuar ka receptura të regjistruara.");
                }
            });
        }
    }

    const saveAndNew = () => {
        setChangeButton(false);
        setOpenDetails(false);

        setForm1IsDisabled(false);
        setForm2IsDisabled(true);

        setArticleCompoundfield(null);
        setCompoundArticleError("");

        setArticleProductionID(0);
        setSimpleArticleID(0);
        setQty(0);

        if (isEditMode) {
            history.push("/produc/normativ");
        }
    }

    const clearEdit = () => {
        setFormDetailData({
            ArticleComponentsID: "",
            ArticleProductionID: "",
            ArticlesID: "",
            Qty: ""
        });

        // clearLine();
        handleOpenForm2();
        setShowError(false);
        setSameArticleError("");
    };
    const handleNewSubmit = (event) => {
        event.preventDefault();

        if (!simpeArticleID) {
            errorAlert("Ju lutem zgjedhni artikullin e thjeshtë");
            return;
        }
        if (!qty) {
            errorAlert("Ju lutem plotësoni sasinë");
            return;
        }

        const stateDate = {
            ArticleProductionID: articleProductionID,
            ArticlesID: simpeArticleID,
            Qty: qty,
            CreatedByUser: email,
        };

        axios.post(ApiLink.API_URL + "Normativi", stateDate, { headers })
            .then(() => {
                handleSuccess("Receptura u shtua me sukses");
                fetchData();
                setSimpleArticleField(null);
                setQty(0);
                setSameArticleError("");
                setShowError(false);
            })
            .catch((error) => {
                errorAlert("Ndodhi një gabim i panjohur.");
                if (error.response) {
                    errorAlert("Ndodhi një gabim i panjohur.");
                }
                if (error.response && error.response.status === 409) {
                    errorAlert(error.response.data);
                } else if (error.response && error.response.status === 400) {
                    errorAlert("Të dhënat nuk janë të sakta. Kontrolloni nëse keni plotësuar çdo fushë.");
                } else {
                    errorAlert("Ndodhi një gabim i panjohur.");
                }
            });
    };

    // Kodi per ruajtjen e te dhenave pas editimint 
    const handleInputChangeDetail = (event) => {
        const { name, value } = event.target;
        setFormDetailData({ ...formDetailData, [name]: value });
    };

    const handleSubmitDetailLine = (event) => {
        event.preventDefault();
        axios
            .put(ApiLink.API_URL + 'Normativi', formDetailData, { headers })
            .then((response) => {
                fetchData();
                handleOpenForm2();
                setSameArticleError("");
                setShowError(false);
            })
            .catch((error) => {
                // console.log(error);
                errorAlert("Deshtoi editimi i recepturës")
            });
    }


    const handleEditDetails = (item) => {
        handleOpenForm1();
        setShowError(false);
        setSameArticleError("");
        setSimpleArticleField(null);
        setQty(0);
        setFormDetailData({
            ArticleComponentsID: item.ArticleComponentsID,
            ArticleProductionID: item.ArticleProductionID,
            ArticlesID: item.ArticlesID,
            Qty: item.Qty,
        });
    };

    const [simpleArticleField, setSimpleArticleField] = useState(null);
    const handleAutocompleteChangeSimpleArticle = (event, value) => {
        if (value && value.ArticleID) {
            // Kontrollo nëse ekziston `value.Barcode` në `data`

            setSimpleArticleID(value.ArticleID);
            setSimpleArticleField(value);
            const exists = data.some(item => item.Barcode === value.Barcode);

            if (exists) {
                setSameArticleError("Kjo recepturë është përdorur në këtë listë, ju vetëm mund ta editoni atë");
                setShowError(true);
                return;
            }
            setSameArticleError("");
            setShowError(false);
        } else {
            setSimpleArticleID(0);
            setSimpleArticleField(null);
        }
    };

    const defaultPropsSimpleArticle = {
        options: simpleArticle,
        getOptionLabel: (option) =>
            `${"Recepturë"} - ${option.ArticleName}` || "",
        renderOption: (props, option) => (
            <>
                <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
                    <span>
                        {option.Barcode}-{"Recepturë"} <br />
                        <b> {option.ArticleName}</b>
                    </span>
                </li>
            </>
        ),
    };
    //Pjesa per select input field artikull te perber
    const [articleCompound, setArticleCompoundfield] = useState(null)
    const handleAutocompleteChangearticleProduction = (event, value) => {
        if (form1IsDisabled) {
            return;
        }

        if (value && value.ArticleID) {
            setArticleProductionID(value.ArticleID);
            setArticleCompoundfield(value);
            setCompoundArticleError("");
        } else {
            setArticleProductionID(0);
            setArticleCompoundfield(null);
        }
    };

    const defaultPropsArticleProduction = {
        options: articleProductions,
        getOptionLabel: (option) =>
            `${option.ArticleProduction == 2 ? "Gjysem Produkt" : "Produkt i Prodhuar"} - ${option.ArticleName}` || "",
        renderOption: (props, option) => (
            <>
                <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
                    <span>
                        {option.Barcode}-{option.ArticleProduction == 2 ? "Gjysem Produkt" : "Produkt i Prodhuar"} <br />
                        <b> {option.ArticleName}</b>
                    </span>
                </li>
            </>
        ),
    };
    ////////////////////////
    const handleAutocompleteChangeArticleEdit = (event, value) => {
        if (value) {
            // Kontrollo nëse ekziston `value.Barcode` në `data`
            const exists = data.some(item => item.Barcode === value.Barcode);

            if (exists) {
                setSameArticleError("Kjo recepturë është përdorur në këtë listë, ju vetëm mund ta editoni atë");
                setShowError(true);
                return;
            }
            setFormDetailData(prevState => ({
                ...prevState,
                ArticlesID: value.ArticleID
            }));
            // fetchArticlesSalesPrice(value.ArticleID, "edit");
        } else {
            setFormDetailData(prevState => ({
                ...prevState,
                ArticlesID: ""
            }));
        }
    };

    const defaultPropsArticleEdit = {
        options: simpleArticle,
        getOptionLabel: (option) =>
            `${option.ArticleProduction == 2 ? "Gjysem Produkt" : "Produkt i Prodhuar"} - ${option.ArticleName}` || "",
        renderOption: (props, option) => (
            <>
                <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
                    <span>
                        {option.Barcode}-{option.ArticleProduction == 2 ? "Gjysem Produkt" : "Produkt i Prodhuar"} <br />
                        {option.ArticleName}
                    </span>
                </li>
            </>
        ),
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            let nextField;
            switch (e.target.id) {
                case 'ArticlesID':
                    if (showError === true) {
                        nextField = document.getElementById('ArticlesID');

                    }
                    else {
                        nextField = document.getElementById('Qty');
                    }
                    break;
                case 'Qty':
                    // if (qty === 0) {
                    //     errorAlert("Ju lutem plotësoni sasinë");
                    //     nextField = document.getElementById('Qty');
                    // }
                    if (showEditForm === true && showInserForm === false && showError === false) {
                        handleSubmitDetailLine(e);
                    } else if (showInserForm === true && showEditForm === false && showError === false) {
                        handleNewSubmit(e);
                    }
                    nextField = document.getElementById('ArticlesID');
                    break;
                default:
                    return;
            }
            if (nextField && nextField.select) {
                nextField.focus();
                nextField.select(); // Shtoni këtë rresht për të selektuar tekstin
            }
        }
    };

    const rows = data.map((item, index) => ({
        id: ++index,
        barcode: item.Barcode,
        name: item.ArticleName,
        unit: item.UnitName,
        qty: item.Qty,
        rowInfo: item,
        deleteItemId: item.ArticleComponentsID
    }));

    const selectedCompound =
        articleCompound || articleProductions.find((item) => Number(item.ArticleID) === Number(articleProductionID));
    const selectedCompoundName = selectedCompound?.ArticleName || "Nuk është zgjedhur";
    const selectedCompoundBarcode = selectedCompound?.Barcode || "-";
    const selectedCompoundType = Number(selectedCompound?.ArticleProduction) === 2 ? "Gjysëm Produkt" : "Produkt i Prodhuar";
    const totalComponents = rows.length;
    const totalQty = rows.reduce((sum, item) => sum + Number(item.qty || 0), 0);

    const [detailsPaginationModel, setDetailsPaginationModel] = useState({ page: 0, pageSize: 10 });
    const [detailsSortModel, setDetailsSortModel] = useState([]);
    const [detailsFilterModel, setDetailsFilterModel] = useState({ items: [] });
    const [detailsQuickFilter, setDetailsQuickFilter] = useState([]);

    const gridVisibleRows = Math.min(Math.max(rows.length, 1), 10);
    const gridHeight = Math.max(460, 220 + gridVisibleRows * 40);

    useEffect(() => {
        fetchArticlesProduction();
        fetchSimpleArticles();
    }, [])

    useEffect(() => {
        if (!isEditMode || !articleProductions.length) {
            return;
        }

        const foundProduction = articleProductions.find(
            (item) => Number(item.ArticleID) === Number(editArticleProductionID)
        );

        if (foundProduction) {
            setArticleCompoundfield(foundProduction);
        }

        setArticleProductionID(editArticleProductionID);
        setCompoundArticleError("");
        setChangeButton(true);
        setOpenDetails(true);
        setForm1IsDisabled(true);
        setForm2IsDisabled(false);

        fetchData(editArticleProductionID);
    }, [isEditMode, editArticleProductionID, articleProductions]);

    return (
        <div className="AccountingSheet__Container normativ-pro">
            {/* Modal per konfirmin nese deshiron me fshi nje element */}
            <Modal show={showDeleteConfirmation} onHide={() => setShowDeleteConfirmation(false)} style={{ marginTop: "150px" }}>
                <Modal.Header>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Are you sure you want to delete?</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteConfirmation(false)}>
                        No
                    </Button>
                    <Button variant="danger" onClick={handleDelete}>
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
            <div className="normativ-pro-header">
                <div className="normativ-pro-header__text">
                    <h2 className="normativ-pro-header__title">
                        {isEditMode ? "Përditëso Normativ" : "Krijo Normativ të ri"}
                    </h2>
                    <p className="normativ-pro-header__subtitle">
                        {isEditMode
                            ? "Forma është hapur në editim dhe të dhënat janë ngarkuar automatikisht nga databaza."
                            : "Ju lutemi vini re se të gjitha te dhenat ruhen automatikisht në bazën e të dhënave për të pasur siguri në cdo hap!"}
                    </p>
                </div>
                <div className="normativ-pro-header__actions">
                    {changeButton ? (
                        <>
                            <button
                                type="button"
                                className="normativ-pro-header__btn normativ-pro-header__btn-secondary normativ-pro-header__btn-pdf"
                                onClick={handleExportNormativPdf}
                                disabled={!isPdfEnabled}
                                title={isPdfEnabled ? "Konverto normativin në PDF" : "PDF aktivizohet pasi të insertohen recepturat"}
                            >
                                <FaFilePdf /> PDF
                            </button>
                            <button
                                type="button"
                                className="normativ-pro-header__btn normativ-pro-header__btn-primary"
                                onClick={saveAndNew}
                            >
                                Ruaj & i Ri
                            </button>
                            <button
                                type="button"
                                className="normativ-pro-header__btn normativ-pro-header__btn-ghost"
                                onClick={() => history.push("/produc/normativ")}
                            >
                                Ruaj & Mbyll
                            </button>
                        </>
                    ) : (
                        <>
                            <button
                                type="button"
                                className="normativ-pro-header__btn normativ-pro-header__btn-secondary normativ-pro-header__btn-pdf"
                                onClick={handleExportNormativPdf}
                                disabled={!isPdfEnabled}
                                title={isPdfEnabled ? "Konverto normativin në PDF" : "PDF aktivizohet pasi të insertohen recepturat"}
                            >
                                <FaFilePdf /> PDF
                            </button>
                            <button
                                type="button"
                                className="normativ-pro-header__btn normativ-pro-header__btn-ghost"
                                onClick={() => history.push("/produc/normativ")}
                            >
                                Mbyll
                            </button>
                        </>
                    )}
                </div>
            </div>

            <hr></hr>
            {/* <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ display: "flex", gap: "5px" }}>
                    <div style={{ display: "flex", }}>
                        <InsertCompoundArticle fetchData={fetchArticlesProduction} type="insert" />
                    </div>
                    <div style={{ display: "flex", }}>
                        <InsertRecepture fetchData={fetchSimpleArticles} type="insert" />
                    </div>
                </div>
                <div style={{ display: "flex" }}>
                    <div style={{ marginLeft: "5px" }}>
                        <LinkAndClickButton
                            text="Mbyll"
                            icon={<FaTimes />}
                            link="/produc/normativ"
                        />
                    </div>
                </div>
            </div > */}
            <div className="normativ-pro-toolbar">
                <div className="normativ-pro-toolbar__left">
                    <div className="normativ-pro-toolbar__item">
                        <CompoundArticleForm fetchData={fetchArticlesProduction} type="insert" />
                    </div>
                    <div className="normativ-pro-toolbar__item">
                        {/* <InsertRecepture fetchData={fetchSimpleArticles} type="insert" /> */}
                        <AddElementsButton
                            text="Krijo Artikull"
                            onClick={() => setIsArticleModalOpen(true)}
                            icon="bi bi-upc-scan"
                            className="button-15"
                        />
                        <ItemFormModal
                            isOpen={isArticleModalOpen}
                            onClose={() => setIsArticleModalOpen(false)}
                            onSuccess={() => { setIsArticleModalOpen(false); fetchSimpleArticles(); }}
                            itemToEdit={null}
                        />
                    </div>
                </div>
                <div className="normativ-pro-toolbar__right"></div>
            </div>
            <Paper className="normativ-pro-main-card">
                <form className='header_paper normativ-pro-select-form'>
                    <Box
                        noValidate
                        autoComplete="off"
                    >
                        <div className="normativ-pro-input-block">
                            <div className="normativ-pro-select-layout">
                                <div className="normativ-pro-select-field">
                                    <Autocomplete
                                        disabled={form1IsDisabled}
                                        fullWidth
                                        {...defaultPropsArticleProduction}
                                        id="ArticleID"
                                        includeInputInList
                                        open={form1IsDisabled ? false : undefined}
                                        value={articleCompound}
                                        onChange={handleAutocompleteChangearticleProduction}
                                        isOptionEqualToValue={(option, value) => option.ArticleID === value.ArticleID}
                                        renderInput={(params) => (
                                            <TextField
                                                style={{ width: "100%", alignItems: "center" }}
                                                {...params}
                                                label="Kerko Artikullin"
                                                disabled={form1IsDisabled}
                                                error={Boolean(compoundArticleError)}
                                                helperText={compoundArticleError}
                                            />
                                        )}
                                        ListboxProps={{
                                            style: {
                                                maxHeight: '250px',
                                                overflow: 'auto',
                                            },
                                        }}
                                    />
                                </div>
                                {!openDetails && (
                                    <div className="normativ-pro-select-cta">
                                        <button className="button-15 normativ-pro-continue-btn" variant="contained"
                                            type="submit"
                                            disabled={form1IsDisabled}
                                            onClick={openRecepturForm}
                                        >
                                            <FaTable /> Vazhdo me regjistrimin e recepturave
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>

                    </Box>
                </form>
                <div className="normativ-pro-space"></div>
                {
                    openDetails ?
                        <div className="SalesDetail__Container normativ-pro-detail-shell">
                            <div className="normativ-pro-detail-bg">
                                <div className="normativ-pro-overview">
                                    <div className="normativ-pro-overview__card normativ-pro-overview__card-main">
                                        <span className="normativ-pro-overview__label">Artikulli i zgjedhur</span>
                                        <strong className="normativ-pro-overview__value">{selectedCompoundName}</strong>
                                        <span className="normativ-pro-overview__meta">Barkodi: {selectedCompoundBarcode}</span>
                                    </div>
                                    <div className="normativ-pro-overview__card">
                                        <span className="normativ-pro-overview__label">Lloji</span>
                                        <strong className="normativ-pro-overview__value">{selectedCompoundType}</strong>
                                    </div>
                                    <div className="normativ-pro-overview__card">
                                        <span className="normativ-pro-overview__label">Komponentë</span>
                                        <strong className="normativ-pro-overview__value">{totalComponents}</strong>
                                    </div>
                                    <div className="normativ-pro-overview__card">
                                        <span className="normativ-pro-overview__label">Totali i sasive</span>
                                        <strong className="normativ-pro-overview__value">
                                            {totalQty.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </strong>
                                    </div>
                                </div>

                                {showInserForm && (
                                    <>
                                    <div className="normativ-pro-block-title">Shto Komponentin</div>
                                    <form onSubmit={handleNewSubmit} className='header_paper normativ-pro-detail-form' onKeyPress={handleKeyPress}>
                                        <Box
                                            noValidate
                                            autoComplete="off"
                                        >
                                            <div className='AccountingSheet__Container__Form'>
                                                <div className="normativ-pro-article-select">
                                                    <Autocomplete
                                                        fullWidth
                                                        {...defaultPropsSimpleArticle}
                                                        id="ArticlesID"
                                                        includeInputInList
                                                        value={simpleArticleField}
                                                        onChange={handleAutocompleteChangeSimpleArticle}
                                                        isOptionEqualToValue={(option, value) => option.ArticleID === value.ArticleID}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                style={{ width: "100%" }}
                                                                {...params}
                                                                label="Përzgjedh artikullin e thjeshtë"
                                                            />
                                                        )}
                                                        ListboxProps={{
                                                            style: {
                                                                maxHeight: '200px',
                                                                overflow: 'auto',
                                                            },
                                                        }}
                                                    />
                                                </div>
                                                <div className='box3'>
                                                    <TextField
                                                        className="AccountingSheet__Container__Form__TextField__5"
                                                        id="Qty"
                                                        label="Sasia"
                                                        variant="outlined"
                                                        autoComplete="off"
                                                        name='QTY'
                                                        value={qty}
                                                        onChange={event => setQty(event.target.value)}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        disabled={form2IsDisabled}
                                                    />
                                                </div>
                                                <div className="butonat normativ-pro-inline-actions">
                                                    <button type="submit"
                                                        className="btn btn-primary float-end normativ-pro-submit-btn"
                                                        disabled={showError}
                                                    >Shto</button>
                                                </div>
                                            </div>
                                            {showError && <span className="normativ-pro-error">{sameArticleError}</span>}

                                        </Box>
                                    </form>
                                    </>
                                )}
                                {showEditForm && (
                                    <>
                                        <div className="normativ-pro-block-title">Përditëso Komponentin</div>
                                        <form onSubmit={handleSubmitDetailLine} className='header_paper normativ-pro-detail-form' onKeyPress={handleKeyPress}>
                                            <Box
                                                noValidate
                                                autoComplete="off"
                                            >
                                                <div className='AccountingSheet__Container__Form'>
                                                    <div className="normativ-pro-article-select">
                                                        <Autocomplete
                                                            fullWidth
                                                            {...defaultPropsArticleEdit}
                                                            id="ArticlesID"
                                                            includeInputInList
                                                            onChange={handleAutocompleteChangeArticleEdit}
                                                            renderInput={(params) => (
                                                                <TextField {...params}
                                                                    style={{ width: "100%" }}
                                                                    label="Përzgjedh artikullin e thjeshtë"
                                                                // variant="filled" 
                                                                />
                                                            )}
                                                            ListboxProps={{
                                                                style: {
                                                                    maxHeight: '200px', // Caktoni një lartësi maksimale për të lejuar vetëm 4 elemente
                                                                    overflow: 'auto',   // Aktivizoni scroll-in për pjesën tjetër
                                                                },
                                                            }}
                                                            value={simpleArticle.find(option => option.ArticleID === formDetailData.ArticlesID) || null}
                                                        />
                                                    </div>
                                                    <div className='box3'>
                                                        <TextField
                                                            className="AccountingSheet__Container__Form__TextField__5"
                                                            type="text"
                                                            id="Qty"
                                                            name="Qty"
                                                            label="Sasia"
                                                            variant="outlined"
                                                            autoComplete="off"
                                                            value={formDetailData.Qty}
                                                            onChange={handleInputChangeDetail}
                                                        />
                                                    </div>
                                                    <div className="butonat normativ-pro-edit-actions">
                                                        <Button type="submit" variant="success" disabled={showError} className="normativ-pro-icon-btn">
                                                            <i class="bi bi-check-lg"></i>
                                                        </Button>
                                                        <Button variant="danger" onClick={clearEdit} className="normativ-pro-icon-btn">
                                                            <i class="bi bi-x-lg"></i>
                                                        </Button>
                                                    </div>
                                                </div>
                                                {showError && <span className="normativ-pro-error">{sameArticleError}</span>}
                                            </Box>
                                        </form>
                                    </>
                                )}
                                <div className="normativ-pro-block-title normativ-pro-block-title--grid">Komponentët e Recepturës</div>
                                <div className="normativ-pro-grid-wrap">
                                    <ReusableServerDataGrid
                                        columns={gridHeader}
                                        rows={rows}
                                        onEdit={(item) => handleEditDetails(item.rowInfo || item)}
                                        onDelete={handleDelete}
                                        showPayment={false}
                                        height={gridHeight}
                                        rowCount={rows.length}
                                        loading={false}
                                        paginationModel={detailsPaginationModel}
                                        setPaginationModel={setDetailsPaginationModel}
                                        sortModel={detailsSortModel}
                                        setSortModel={setDetailsSortModel}
                                        filterModel={detailsFilterModel}
                                        setFilterModel={setDetailsFilterModel}
                                        quickFilter={detailsQuickFilter}
                                        setQuickFilter={setDetailsQuickFilter}
                                    />
                                </div>
                            </div>
                        </div>
                        : null
                }
                <div className="normativ-pro-space-sm"></div>
            </Paper>
        </div>
    );
}

export default StandardNormativForm;